import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import usePedWorkspace from '@/data/hook/ped-content/usePedWorkspace';

type PedWorkspaceStatus = {
  isPublished: boolean;
  isLimitedEdition: boolean;
};

const PedWorkspaceContext = createContext<PedWorkspaceStatus>({
  isPublished: false,
  isLimitedEdition: false,
});

export function PedWorkspaceProvider({ children }: PropsWithChildren) {
  const { isPublished, isLimitedEdition } = usePedWorkspace();

  const content = useMemo(
    () => ({
      isPublished,
      isLimitedEdition,
    }),
    [isPublished, isLimitedEdition],
  );

  return (
    <PedWorkspaceContext.Provider value={content}>
      {children}
    </PedWorkspaceContext.Provider>
  );
}

export const usePedWorkspaceStatus = () => useContext(PedWorkspaceContext);

export default PedWorkspaceContext;
